interface Option {
    label: string;
    value: string;
}
export const stateOptions: Option[] = [
    {
        label: 'All states',
        value: 'All',
    },
    {
        label: 'NSW',
        value: 'NSW',
    },
    {
        label: 'VIC',
        value: 'VIC',
    },
    {
        label: 'QLD',
        value: 'QLD',
    },
    {
        label: 'SA',
        value: 'SA',
    },
    {
        label: 'WA',
        value: 'WA',
    },
    {
        label: 'TAS',
        value: 'TAS',
    },
    {
        label: 'ACT',
        value: 'ACT',
    },
    {
        label: 'NT',
        value: 'NT',
    },
];
export const onlineOptions = [
    {
        label: 'All users',
        value: 'All',
    },
    {
        label: 'Online users',
        value: 'Online',
    },
    {
        label: 'Offline users',
        value: 'Offline',
    },
];
export const delayTimeOptions = [
    {
        label: '30 minutes',
        value: '1800',
    },
    {
        label: '1 hour',
        value: '3600',
    },
    {
        label: '2 hours',
        value: '7200',
    },
    {
        label: '3 hours',
        value: '10800',
    },
    {
        label: '4 hours',
        value: '14400',
    },
    {
        label: '6 hours',
        value: '21600',
    },
    {
        label: '8 hours',
        value: '28800',
    },
    {
        label: '12 hours',
        value: '43200',
    },
];
export const couponStatus = {
    Active: {
        label: 'Active',
        value: 'Active',
        color: '#7DB8A4',
    },
    'Not Started': {
        label: 'Not started',
        value: 'Not started',
        color: '#052588',
    },
    Expired: {
        label: 'Expired',
        value: 'Expired',
        color: '#979797',
    },
    'All Used': {
        label: 'Expired',
        value: 'Expired',
        color: '#979797',
    },
};
